import { TextFunction } from '../../hooks/localizedText';

/**
 * Formats attendance time in minutes to a human-readable display.
 * Uses i18n translations for proper localization.
 *
 * @param minutes - Number of minutes to format
 * @param t - translation function. Its strings are keyed in the eventViewing bundle only, so a
 * migrated caller must pass a reader that declares `eventViewing` — otherwise the duration silently
 * falls back to English while the text around it is translated.
 * @returns Formatted time string (e.g., "2 hrs 30 mins", "1 hr", "45 mins")
 *
 * @example
 * formatAttendanceTimeDisplay(60, t) // "1 hr"
 * formatAttendanceTimeDisplay(90, t) // "1 hr 30 mins"
 * formatAttendanceTimeDisplay(120, t) // "2 hrs"
 * formatAttendanceTimeDisplay(45, t) // "45 mins"
 */
export function formatAttendanceTimeDisplay(minutes: number, t: TextFunction): string {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (hours === 0) {
    return t('eventDetails.shiftDisplay.attendanceTimeInMinutes', {
      minutes: remainingMinutes,
    });
  }
  if (remainingMinutes === 0) {
    return t('eventDetails.shiftDisplay.attendanceTimeInHour', {
      hours: hours,
    });
  }
  return t('eventDetails.shiftDisplay.attendanceTimeInHourAndMinutes', {
    hours: hours,
    minutes: remainingMinutes,
  });
}
